import React from "react"
import { SmallText } from "../../SignUp/SignUpCard/styles"
import ProspectForm from "../../../pages/ProspectRegistration/Form"
import { StyledModal } from "./StyledModal"
import { useModal } from "./ModalContext"
import { withRouter } from "react-router-dom"

const ProspectModal = ({ history }) => {
  const { activeModal, closeModal } = useModal()

  if (activeModal !== "prospect") return null

  return (
    <StyledModal
      isOpen
      onClose={closeModal}
      data-testid="get-started-modal"
      title="Path To Membership"
    >
      <SmallText className="mt-2 mb-4">
        Hi! Get started on your path to membership by filling out the required
        fields below.
      </SmallText>
      <ProspectForm history={history} />
    </StyledModal>
  )
}

export default withRouter(ProspectModal)
